import { MockupWithImagesViewModel } from '../../api/clientInterfaces/MockupModel';

export const mockupsList: MockupWithImagesViewModel[] = [];
